/**
 * Fuel on the desk is whole pounds. Gallons and flow rates stay as they are.
 * A fractional pound is rounded at the boundary. Negative pounds stay negative
 * so the invariant can still name them. Nothing here drops a trip.
 */

const FUEL_LB_KEYS = new Set([
  "fuelLbs",
  "releasedFuelLbs",
  "fuelLb",
  "secondFuelLb",
  "fuelQtyLb",
  "tankCenterLb",
  "tankLeftMainLb",
  "tankRightMainLb",
  "tankLeftAuxLb",
  "tankRightAuxLb",
  "onBoardLb",
  "fuelOutLb",
  "fuelOffLb",
  "fuelOnLb",
  "fuelInLb",
  "actualFuelLb",
]);

/** Original career blob, written before a fractional-pound repair replaces the working copy. */
export const FUEL_LB_BACKUP_KEY = "ns.dispatch.store.fuel-lb-backup";

export function wholeFuelLb(value: number): number {
  if (!Number.isFinite(value)) return value;
  return Math.round(value);
}

export function repairStoredFuelPounds(raw: string): { value: string; changed: boolean } {
  let parsed: unknown;
  try {
    parsed = JSON.parse(raw);
  } catch {
    return { value: raw, changed: false };
  }
  let changed = false;
  const walk = (node: unknown): unknown => {
    if (Array.isArray(node)) return node.map(walk);
    if (!node || typeof node !== "object") return node;
    const out: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(node as Record<string, unknown>)) {
      if (FUEL_LB_KEYS.has(key) && typeof value === "number" && Number.isFinite(value) && !Number.isInteger(value)) {
        out[key] = wholeFuelLb(value);
        changed = true;
      } else if (value && typeof value === "object") {
        out[key] = walk(value);
      } else {
        out[key] = value;
      }
    }
    return out;
  };
  const next = walk(parsed);
  if (!changed) return { value: raw, changed: false };
  return { value: JSON.stringify(next), changed: true };
}
